// extracted by mini-css-extract-plugin
export default {"noUsers":"DashedBorderBox_noUsers__5bjC1"};